import styled from "@xstyled/styled-components";
import { tokens } from "../../../utils/theme";



export const Overlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(4, 7, 18, 0.82);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1200;
    animation: fadeIn 0.2s ease-out;

    @keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
    }
`;

export const Container = styled.div`
    width: 94vw;
    max-width: 1280px;
    height: 88vh;
    max-height: 920px;
    background: ${props => props.theme.palette.mode === 'dark'
        ? 'linear-gradient(155deg, rgba(22, 27, 44, 0.98) 0%, rgba(12, 16, 28, 0.96) 100%)'
        : 'linear-gradient(155deg, rgba(255, 255, 255, 0.98) 0%, rgba(244, 246, 250, 0.96) 100%)'};
    border: 1px solid ${props => props.theme.palette.mode === 'dark'
        ? 'rgba(128, 203, 196, 0.25)'
        : 'rgba(15, 118, 110, 0.2)'};
    box-shadow: 0 24px 70px rgba(0, 0, 0, 0.65), 0 0 40px rgba(76, 206, 172, 0.1);
    border-radius: 20px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    position: relative;
`;

export const Header = styled.div`
    padding: 18px 24px;
    border-bottom: 1px solid ${props => props.theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.08)' : 'rgba(0, 0, 0, 0.07)'};
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    background: ${props => props.theme.palette.mode === 'dark' ? 'rgba(16, 20, 34, 0.6)' : 'rgba(255, 255, 255, 0.6)'};
`;

export const HeaderTitleBlock = styled.div`
    display: flex;
    align-items: center;
    gap: 14px;
`;

export const IconBadge = styled.div`
    width: 42px;
    height: 42px;
    border-radius: 12px;
    background: ${props => props.theme.palette.mode === 'dark'
        ? 'linear-gradient(135deg, rgba(128, 203, 196, 0.2), rgba(68, 138, 255, 0.15))'
        : 'linear-gradient(135deg, rgba(15, 118, 110, 0.15), rgba(68, 138, 255, 0.1))'};
    border: 1px solid ${props => props.theme.palette.mode === 'dark' ? 'rgba(128, 203, 196, 0.35)' : 'rgba(15, 118, 110, 0.3)'};
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${props => props.theme.palette.primary.main};
    box-shadow: 0 4px 14px rgba(76, 206, 172, 0.15);
    cursor: pointer;
    user-select: none;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);

    &:hover {
        transform: translateY(-1.5px) scale(1.05);
        border-color: ${props => props.theme.palette.primary.main};
        box-shadow: 0 6px 18px rgba(76, 206, 172, 0.35);
    }

    &:active {
        transform: translateY(0) scale(0.98);
    }
`;

export const Title = styled.h2`
    margin: 0;
    font-size: 1.25rem;
    font-weight: 700;
    color: ${props => props.theme.palette.mode === 'dark' ? '#fff' : tokens(props.theme.palette.mode).grey[100]};
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
    user-select: none;
    transition: color 0.18s ease;

    &:hover {
        color: ${props => props.theme.palette.primary.main};
    }
`;

export const NavArrowsGroup = styled.div`
    display: flex;
    align-items: center;
    gap: 3px;
    background: ${props => props.theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.04)'};
    border: 1px solid ${props => props.theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.08)' : 'rgba(0, 0, 0, 0.08)'};
    border-radius: 8px;
    padding: 2px;
`;

export const NavArrowBtn = styled.button`
    width: 28px;
    height: 28px;
    border-radius: 6px;
    border: none;
    background: transparent;
    color: ${props => props.disabled
        ? (props.theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.18)' : 'rgba(0, 0, 0, 0.18)')
        : (props.theme.palette.mode === 'dark' ? '#cfd8dc' : '#334155')};
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
    transition: all 0.15s ease;

    &:hover:not(:disabled) {
        background: ${props => props.theme.palette.mode === 'dark' ? 'rgba(128, 203, 196, 0.2)' : 'rgba(15, 118, 110, 0.12)'};
        color: ${props => props.theme.palette.primary.main};
    }
`;

export const HomeContainer = styled.div`
    flex: 1;
    overflow-y: auto;
    padding: 24px 32px 36px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    min-height: 0;

    &::-webkit-scrollbar {
        width: 8px;
    }
    &::-webkit-scrollbar-track {
        background: ${props => props.theme.palette.mode === 'dark' ? 'rgba(0, 0, 0, 0.2)' : 'rgba(0, 0, 0, 0.04)'};
        border-radius: 4px;
    }
    &::-webkit-scrollbar-thumb {
        background: ${props => props.theme.palette.mode === 'dark'
            ? 'linear-gradient(180deg, #80cbc4, #4cceac)'
            : 'linear-gradient(180deg, #0f766e, #14b8a6)'};
        border-radius: 4px;
        border: 2px solid transparent;
        background-clip: content-box;
    }
`;

export const HomeHero = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid ${props => props.theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.06)' : 'rgba(0, 0, 0, 0.06)'};
    padding-bottom: 14px;
    gap: 12px;
    flex-wrap: wrap;
`;

export const HomeHeroTitle = styled.h3`
    margin: 0;
    font-size: 1.1rem;
    font-weight: 700;
    color: ${props => props.theme.palette.mode === 'dark' ? '#f1f5f9' : '#0f172a'};
    display: flex;
    align-items: center;
    gap: 10px;
`;

export const DocsCountPill = styled.span`
    font-size: 0.75rem;
    font-weight: 600;
    padding: 2px 10px;
    border-radius: 999px;
    background: ${props => props.theme.palette.mode === 'dark' ? 'rgba(128, 203, 196, 0.15)' : 'rgba(15, 118, 110, 0.1)'};
    color: ${props => props.theme.palette.primary.main};
    border: 1px solid ${props => props.theme.palette.mode === 'dark' ? 'rgba(128, 203, 196, 0.3)' : 'rgba(15, 118, 110, 0.2)'};
`;

export const HomeCategoriesList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const HomeCategorySection = styled.div`
    display: flex;
    flex-direction: column;
    border-radius: 14px;
    background: ${props => props.theme.palette.mode === 'dark'
        ? (props.$isExpanded ? 'rgba(18, 23, 38, 0.5)' : 'rgba(18, 23, 38, 0.35)')
        : (props.$isExpanded ? 'rgba(255, 255, 255, 0.85)' : 'rgba(246, 248, 252, 0.75)')};
    border: 1px solid ${props => props.$isExpanded
        ? (props.theme.palette.mode === 'dark' ? 'rgba(128, 203, 196, 0.25)' : 'rgba(15, 118, 110, 0.25)')
        : (props.theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.07)' : 'rgba(0, 0, 0, 0.07)')};
    transition: all 0.22s cubic-bezier(0.4, 0, 0.2, 1);
    overflow: hidden;

    &:hover {
        border-color: ${props => props.theme.palette.mode === 'dark' ? 'rgba(128, 203, 196, 0.4)' : 'rgba(15, 118, 110, 0.4)'};
        box-shadow: ${props => props.theme.palette.mode === 'dark'
            ? '0 6px 20px rgba(0, 0, 0, 0.25)'
            : '0 6px 20px rgba(0, 0, 0, 0.05)'};
    }
`;

export const HomeCategoryHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 22px;
    cursor: pointer;
    user-select: none;
    transition: background 0.18s ease;
    background: ${props => props.$isExpanded
        ? (props.theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.02)' : 'rgba(0, 0, 0, 0.015)')
        : 'transparent'};

    &:hover {
        background: ${props => props.theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.04)' : 'rgba(0, 0, 0, 0.03)'};
    }
`;

export const HomeCategoryHeaderLeft = styled.div`
    display: flex;
    align-items: center;
    gap: 14px;
    min-width: 0;
    overflow: hidden;
`;

export const HomeCategoryIconWrapper = styled.div`
    width: 36px;
    height: 36px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    background: ${props => props.$isExpanded
        ? (props.theme.palette.mode === 'dark' ? 'rgba(76, 206, 172, 0.16)' : 'rgba(15, 118, 110, 0.12)')
        : (props.theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.06)' : 'rgba(0, 0, 0, 0.05)')};
    color: ${props => props.$isExpanded
        ? (props.theme.palette.mode === 'dark' ? '#80cbc4' : '#0f766e')
        : (props.theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.6)' : 'rgba(0, 0, 0, 0.6)')};
    border: 1px solid ${props => props.$isExpanded
        ? (props.theme.palette.mode === 'dark' ? 'rgba(128, 203, 196, 0.3)' : 'rgba(15, 118, 110, 0.3)')
        : 'transparent'};
    transition: all 0.2s ease;
`;

export const HomeCategoryTitle = styled.h4`
    margin: 0;
    font-size: 1.02rem;
    font-weight: 700;
    letter-spacing: 0.02em;
    color: ${props => props.theme.palette.mode === 'dark' ? '#ffffff' : '#0f172a'};
    line-height: 1.25;
`;

export const HomeCategoryPreviewText = styled.p`
    margin: 3px 0 0;
    font-size: 0.78rem;
    color: ${props => tokens(props.theme.palette.mode).grey[400]};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 520px;
`;

export const HomeCategoryHeaderRight = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    flex-shrink: 0;
`;

export const HomeCategoryChevron = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: ${props => props.theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.5)' : 'rgba(0, 0, 0, 0.5)'};
    transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1), color 0.18s ease;
    transform: ${props => props.$isExpanded ? 'rotate(180deg)' : 'rotate(0deg)'};

    ${HomeCategoryHeader}:hover & {
        color: ${props => props.theme.palette.mode === 'dark' ? '#80cbc4' : '#0f766e'};
    }
`;

export const HomeCategoryCardsWrapper = styled.div`
    padding: 6px 20px 20px;
    border-top: 1px solid ${props => props.theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.05)'};
    animation: fadeIn 0.2s ease-out;

    @keyframes fadeIn {
        from { opacity: 0; transform: translateY(-4px); }
        to { opacity: 1; transform: translateY(0); }
    }
`;

export const HomeExpandAllBtn = styled.button`
    width: 32px;
    height: 32px;
    padding: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: 1px solid ${props => props.theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)'};
    border-radius: 8px;
    color: ${props => props.theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.7)' : 'rgba(0, 0, 0, 0.7)'};
    cursor: pointer;
    transition: all 0.18s ease;

    &:hover {
        background: ${props => props.theme.palette.mode === 'dark' ? 'rgba(128, 203, 196, 0.12)' : 'rgba(15, 118, 110, 0.08)'};
        color: ${props => props.theme.palette.mode === 'dark' ? '#80cbc4' : '#0f766e'};
        border-color: ${props => props.theme.palette.mode === 'dark' ? 'rgba(128, 203, 196, 0.3)' : 'rgba(15, 118, 110, 0.3)'};
        transform: translateY(-1px);
    }
`;

export const HomeHeroActions = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
`;

export const DownloadAllPdfBtn = styled.button`
    width: 32px;
    height: 32px;
    padding: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s ease;
    border: 1px solid ${props => props.theme.palette.mode === 'dark' ? 'rgba(56, 189, 248, 0.45)' : 'rgba(2, 132, 199, 0.4)'};
    background: ${props => props.theme.palette.mode === 'dark'
        ? 'linear-gradient(135deg, rgba(2, 132, 199, 0.22), rgba(15, 118, 110, 0.2))'
        : 'linear-gradient(135deg, rgba(2, 132, 199, 0.12), rgba(15, 118, 110, 0.1))'};
    color: ${props => props.theme.palette.mode === 'dark' ? '#38bdf8' : '#0284c7'};
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);

    &:hover:not(:disabled) {
        background: ${props => props.theme.palette.mode === 'dark'
            ? 'linear-gradient(135deg, rgba(2, 132, 199, 0.38), rgba(15, 118, 110, 0.35))'
            : 'linear-gradient(135deg, rgba(2, 132, 199, 0.22), rgba(15, 118, 110, 0.18))'};
        border-color: ${props => props.theme.palette.mode === 'dark' ? '#38bdf8' : '#0284c7'};
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(2, 132, 199, 0.25);
    }

    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }

    .pdf-spin {
        animation: pdfSpin 1s linear infinite;
    }

    @keyframes pdfSpin {
        from { transform: rotate(0deg); }
        to { transform: rotate(360deg); }
    }
`;

export const HomeBlueprintBtn = styled.button`
    width: 32px;
    height: 32px;
    padding: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s ease;
    border: 1px solid ${props => props.$active
        ? (props.theme.palette.mode === 'dark' ? '#818cf8' : '#6366f1')
        : (props.theme.palette.mode === 'dark' ? 'rgba(129, 140, 248, 0.45)' : 'rgba(99, 102, 241, 0.4)')};
    background: ${props => props.$active
        ? (props.theme.palette.mode === 'dark' ? 'rgba(99, 102, 241, 0.3)' : 'rgba(99, 102, 241, 0.2)')
        : (props.theme.palette.mode === 'dark'
            ? 'linear-gradient(135deg, rgba(99, 102, 241, 0.2), rgba(129, 140, 248, 0.12))'
            : 'linear-gradient(135deg, rgba(99, 102, 241, 0.1), rgba(129, 140, 248, 0.08))')};
    color: ${props => props.theme.palette.mode === 'dark' ? '#a5b4fc' : '#4f46e5'};
    box-shadow: ${props => props.$active
        ? '0 2px 8px rgba(99, 102, 241, 0.35)'
        : '0 2px 6px rgba(0, 0, 0, 0.12)'};

    &:hover {
        background: ${props => props.theme.palette.mode === 'dark'
            ? 'linear-gradient(135deg, rgba(99, 102, 241, 0.38), rgba(129, 140, 248, 0.26))'
            : 'linear-gradient(135deg, rgba(99, 102, 241, 0.2), rgba(129, 140, 248, 0.15))'};
        border-color: ${props => props.theme.palette.mode === 'dark' ? '#a5b4fc' : '#6366f1'};
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(99, 102, 241, 0.25);
    }
`;

export const BlueprintTopRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 14px;
    gap: 12px;
    flex-wrap: wrap;
`;

export const BlueprintCopyBtn = styled.button`
    width: 28px;
    height: 28px;
    padding: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 7px;
    border: 1px solid ${props => props.theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)'};
    background: ${props => props.theme.palette.mode === 'dark' ? 'rgba(30, 41, 59, 0.65)' : 'rgba(241, 245, 249, 0.85)'};
    color: ${props => props.theme.palette.mode === 'dark' ? '#e2e8f0' : '#1e293b'};
    cursor: pointer;
    transition: all 0.18s ease;

    &:hover {
        background: ${props => props.theme.palette.mode === 'dark' ? 'rgba(128, 203, 196, 0.15)' : 'rgba(15, 118, 110, 0.1)'};
        color: ${props => props.theme.palette.mode === 'dark' ? '#80cbc4' : '#0f766e'};
        border-color: ${props => props.theme.palette.mode === 'dark' ? 'rgba(128, 203, 196, 0.45)' : 'rgba(15, 118, 110, 0.35)'};
        transform: translateY(-1px);
    }
`;

export const BlueprintContainer = styled.div`
    background: ${props => props.theme.palette.mode === 'dark'
        ? 'linear-gradient(145deg, rgba(17, 24, 39, 0.85), rgba(15, 23, 42, 0.95))'
        : 'linear-gradient(145deg, rgba(255, 255, 255, 0.98), rgba(248, 250, 252, 0.95))'};
    border: 1px solid ${props => props.theme.palette.mode === 'dark' ? 'rgba(129, 140, 248, 0.28)' : 'rgba(99, 102, 241, 0.22)'};
    border-radius: 16px;
    padding: 22px;
    margin-bottom: 24px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
    animation: fadeIn 0.25s ease-out;

    @media (max-width: 640px) {
        padding: 16px;
    }
`;

export const BlueprintSectionTitle = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 12px;
    font-size: 0.86rem;
    font-weight: 700;
    color: ${props => props.theme.palette.mode === 'dark' ? '#e2e8f0' : '#1e293b'};
    letter-spacing: -0.2px;
`;

export const BlueprintPillarsGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(290px, 1fr));
    gap: 14px;
    margin-bottom: 22px;
`;

export const BlueprintPillarCard = styled.div`
    background: ${props => props.theme.palette.mode === 'dark'
        ? 'rgba(15, 23, 42, 0.65)'
        : 'rgba(248, 250, 252, 0.85)'};
    border: 1px solid ${props => props.theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.07)' : 'rgba(0, 0, 0, 0.07)'};
    border-radius: 12px;
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    transition: all 0.2s ease;

    &:hover {
        border-color: ${props => props.theme.palette.mode === 'dark' ? 'rgba(129, 140, 248, 0.4)' : 'rgba(99, 102, 241, 0.35)'};
        transform: translateY(-2px);
    }
`;

export const PillarHeader = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
`;

export const PillarTag = styled.span`
    align-self: flex-start;
    font-size: 0.65rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    padding: 2px 7px;
    border-radius: 5px;
    background: ${props => {
        if (props.$variant === 'amber') return props.theme.palette.mode === 'dark' ? 'rgba(245, 158, 11, 0.18)' : 'rgba(217, 119, 6, 0.12)';
        if (props.$variant === 'cyan') return props.theme.palette.mode === 'dark' ? 'rgba(56, 189, 248, 0.18)' : 'rgba(2, 132, 199, 0.12)';
        if (props.$variant === 'emerald') return props.theme.palette.mode === 'dark' ? 'rgba(16, 185, 129, 0.18)' : 'rgba(16, 185, 129, 0.12)';
        return 'rgba(99, 102, 241, 0.15)';
    }};
    color: ${props => {
        if (props.$variant === 'amber') return props.theme.palette.mode === 'dark' ? '#fbbf24' : '#d97706';
        if (props.$variant === 'cyan') return props.theme.palette.mode === 'dark' ? '#38bdf8' : '#0284c7';
        if (props.$variant === 'emerald') return props.theme.palette.mode === 'dark' ? '#34d399' : '#059669';
        return '#818cf8';
    }};
`;

export const PillarTitle = styled.h4`
    margin: 0;
    font-size: 0.88rem;
    font-weight: 700;
    color: ${props => props.theme.palette.mode === 'dark' ? '#f1f5f9' : '#0f172a'};
    line-height: 1.35;
`;

export const PillarBody = styled.div`
    font-size: 0.78rem;
    line-height: 1.55;
    color: ${props => tokens(props.theme.palette.mode).grey[400]};
    display: flex;
    flex-direction: column;
    gap: 8px;

    .pillar-bullet {
        position: relative;
        padding-left: 12px;
        &:before {
            content: "•";
            position: absolute;
            left: 0;
            color: ${props => props.theme.palette.mode === 'dark' ? '#818cf8' : '#6366f1'};
            font-weight: bold;
        }
    }
`;

export const PillarHighlight = styled.div`
    margin-top: 4px;
    padding: 8px 10px;
    border-radius: 8px;
    background: ${props => props.theme.palette.mode === 'dark' ? 'rgba(99, 102, 241, 0.1)' : 'rgba(99, 102, 241, 0.05)'};
    border-left: 3px solid ${props => props.theme.palette.mode === 'dark' ? '#818cf8' : '#6366f1'};
    font-size: 0.75rem;
    line-height: 1.45;
    color: ${props => props.theme.palette.mode === 'dark' ? '#c7d2fe' : '#3730a3'};
`;

export const BlueprintStagesWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-bottom: 22px;
`;

export const StageCard = styled.div`
    background: ${props => props.theme.palette.mode === 'dark'
        ? 'rgba(15, 23, 42, 0.6)'
        : 'rgba(255, 255, 255, 0.85)'};
    border: 1px solid ${props => props.theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.07)' : 'rgba(0, 0, 0, 0.07)'};
    border-left: 4px solid ${props => props.$borderAccent || '#6366f1'};
    border-radius: 10px;
    padding: 14px 18px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    transition: all 0.2s ease;

    &:hover {
        border-color: ${props => props.$borderAccent || '#6366f1'};
        transform: translateX(2px);
    }
`;

export const StageHeader = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
`;

export const StageNumber = styled.span`
    width: 26px;
    height: 26px;
    border-radius: 7px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.75rem;
    font-weight: 800;
    background: ${props => props.$bg || 'rgba(99, 102, 241, 0.15)'};
    color: ${props => props.$color || '#818cf8'};
    flex-shrink: 0;
`;

export const StageTitleWrapper = styled.div`
    display: flex;
    align-items: baseline;
    gap: 10px;
    flex-wrap: wrap;
`;

export const StageTitle = styled.h4`
    margin: 0;
    font-size: 0.92rem;
    font-weight: 800;
    color: ${props => props.theme.palette.mode === 'dark' ? '#f8fafc' : '#0f172a'};
`;

export const StageTagline = styled.span`
    font-size: 0.76rem;
    color: ${props => tokens(props.theme.palette.mode).grey[400]};
    font-style: italic;
`;

export const StageRoleDesc = styled.p`
    margin: 0;
    font-size: 0.78rem;
    line-height: 1.5;
    color: ${props => tokens(props.theme.palette.mode).grey[300]};
`;

export const StageDocChips = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 2px;
`;

export const BlueprintDocChip = styled.button`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 5px 10px;
    border-radius: 7px;
    font-size: 0.74rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.18s ease;
    border: 1px solid ${props => props.theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)'};
    background: ${props => props.theme.palette.mode === 'dark' ? 'rgba(30, 41, 59, 0.7)' : 'rgba(241, 245, 249, 0.9)'};
    color: ${props => props.theme.palette.mode === 'dark' ? '#e2e8f0' : '#1e293b'};

    .doc-num {
        font-size: 0.65rem;
        opacity: 0.6;
        font-family: monospace;
    }

    .doc-arrow {
        opacity: 0.4;
        transition: transform 0.18s ease, opacity 0.18s ease;
    }

    &:hover {
        border-color: ${props => props.theme.palette.primary.main};
        background: ${props => props.theme.palette.mode === 'dark' ? 'rgba(128, 203, 196, 0.15)' : 'rgba(15, 118, 110, 0.1)'};
        color: ${props => props.theme.palette.mode === 'dark' ? '#80cbc4' : '#0f766e'};
        transform: translateY(-1px);

        .doc-arrow {
            opacity: 1;
            transform: translateX(2px);
        }
    }
`;

export const WorkflowContainer = styled.div`
    background: ${props => props.theme.palette.mode === 'dark'
        ? 'rgba(15, 23, 42, 0.8)'
        : 'rgba(248, 250, 252, 0.95)'};
    border: 1px solid ${props => props.theme.palette.mode === 'dark' ? 'rgba(128, 203, 196, 0.25)' : 'rgba(15, 118, 110, 0.2)'};
    border-radius: 12px;
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const WorkflowHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    color: ${props => props.theme.palette.mode === 'dark' ? '#f1f5f9' : '#0f172a'};
`;

export const WorkflowStepsGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(130px, 1fr));
    gap: 8px;
`;

export const WorkflowStepBox = styled.button`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 10px 12px;
    border-radius: 8px;
    border: 1px solid ${props => props.theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.08)' : 'rgba(0, 0, 0, 0.08)'};
    background: ${props => props.theme.palette.mode === 'dark' ? 'rgba(30, 41, 59, 0.55)' : 'rgba(255, 255, 255, 0.8)'};
    cursor: pointer;
    transition: all 0.18s ease;
    text-align: left;

    &:hover {
        border-color: ${props => props.theme.palette.mode === 'dark' ? '#80cbc4' : '#0f766e'};
        background: ${props => props.theme.palette.mode === 'dark' ? 'rgba(128, 203, 196, 0.12)' : 'rgba(15, 118, 110, 0.08)'};
        transform: translateY(-2px);
    }
`;

export const WorkflowStepNumber = styled.span`
    font-size: 0.65rem;
    font-weight: 800;
    padding: 1px 5px;
    border-radius: 4px;
    margin-bottom: 6px;
    background: ${props => props.theme.palette.mode === 'dark' ? 'rgba(128, 203, 196, 0.2)' : 'rgba(15, 118, 110, 0.12)'};
    color: ${props => props.theme.palette.mode === 'dark' ? '#80cbc4' : '#0f766e'};
`;

export const WorkflowStepText = styled.span`
    font-size: 0.74rem;
    font-weight: 700;
    color: ${props => props.theme.palette.mode === 'dark' ? '#f8fafc' : '#0f172a'};
    line-height: 1.25;
`;

export const WorkflowStepSub = styled.span`
    font-size: 0.66rem;
    color: ${props => tokens(props.theme.palette.mode).grey[400]};
    margin-top: 3px;
    line-height: 1.2;
`;

export const DocCardsGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
    gap: 16px;
`;

export const DocCard = styled.div`
    background: ${props => props.theme.palette.mode === 'dark'
        ? 'linear-gradient(145deg, rgba(22, 28, 46, 0.7), rgba(14, 18, 32, 0.9))'
        : 'linear-gradient(145deg, rgba(255, 255, 255, 0.95), rgba(246, 248, 252, 0.9))'};
    border: 1px solid ${props => props.theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.08)' : 'rgba(0, 0, 0, 0.08)'};
    border-radius: 14px;
    padding: 18px 20px;
    cursor: pointer;
    transition: all 0.22s cubic-bezier(0.4, 0, 0.2, 1);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 12px;
    position: relative;
    overflow: hidden;

    &:hover {
        transform: translateY(-3px);
        border-color: ${props => props.theme.palette.primary.main};
        box-shadow: 0 14px 35px rgba(0, 0, 0, 0.45), 0 0 20px rgba(76, 206, 172, 0.12);
    }
`;

export const DocCardHeader = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 10px;
`;

export const DocCardTitle = styled.h4`
    margin: 0;
    font-size: 0.96rem;
    font-weight: 700;
    color: ${props => props.theme.palette.mode === 'dark' ? '#ffffff' : '#0f172a'};
    line-height: 1.35;
`;

export const DocCardDesc = styled.p`
    margin: 0;
    font-size: 0.82rem;
    line-height: 1.55;
    color: ${props => tokens(props.theme.palette.mode).grey[400]};
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
`;

export const DocCardFooter = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    border-top: 1px solid ${props => props.theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.04)' : 'rgba(0, 0, 0, 0.04)'};
    padding-top: 10px;
`;

export const ViewDocPrompt = styled.span`
    font-size: 0.78rem;
    font-weight: 600;
    color: ${props => props.theme.palette.primary.main};
    display: flex;
    align-items: center;
    gap: 4px;
    transition: transform 0.2s;

    ${DocCard}:hover & {
        transform: translateX(3px);
    }
`;

export const HeaderActions = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
`;

export const ActionBtn = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: ${props => props.iconOnly ? '0' : '7px 14px'};
    width: ${props => props.iconOnly ? '34px' : 'auto'};
    height: 34px;
    border-radius: 8px;
    font-size: 0.82rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    border: 1px solid ${props => {
        if (props.primary) return props.theme.palette.mode === 'dark' ? 'rgba(128, 203, 196, 0.6)' : 'rgba(15, 118, 110, 0.5)';
        if (props.danger) return props.theme.palette.mode === 'dark' ? 'rgba(239, 83, 80, 0.5)' : 'rgba(225, 29, 72, 0.4)';
        return props.theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.1)';
    }};
    background: ${props => {
        if (props.primary) return props.theme.palette.mode === 'dark' ? 'rgba(128, 203, 196, 0.15)' : 'rgba(15, 118, 110, 0.12)';
        if (props.danger) return props.theme.palette.mode === 'dark' ? 'rgba(239, 83, 80, 0.15)' : 'rgba(225, 29, 72, 0.1)';
        return props.theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.04)';
    }};
    color: ${props => {
        if (props.primary) return props.theme.palette.mode === 'dark' ? '#80cbc4' : '#0f766e';
        if (props.danger) return props.theme.palette.mode === 'dark' ? '#ef5350' : '#be123c';
        return props.theme.palette.mode === 'dark' ? '#cfd8dc' : '#334155';
    }};

    &:hover {
        background: ${props => {
            if (props.primary) return props.theme.palette.mode === 'dark' ? 'rgba(128, 203, 196, 0.28)' : 'rgba(15, 118, 110, 0.2)';
            if (props.danger) return props.theme.palette.mode === 'dark' ? 'rgba(239, 83, 80, 0.25)' : 'rgba(225, 29, 72, 0.18)';
            return props.theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.08)';
        }};
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
    }
`;

export const CloseBtn = styled.button`
    width: 34px;
    height: 34px;
    border-radius: 8px;
    border: 1px solid ${props => props.theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)'};
    background: transparent;
    color: ${props => tokens(props.theme.palette.mode).grey[300]};
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
        background: ${props => props.theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.08)'};
        color: #fff;
        transform: scale(1.05);
    }
`;

export const Toolbar = styled.div`
    padding: 12px 24px;
    border-bottom: 1px solid ${props => props.theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.05)'};
    display: flex;
    align-items: center;
    background: ${props => props.theme.palette.mode === 'dark' ? 'rgba(12, 16, 28, 0.4)' : 'rgba(250, 250, 250, 0.5)'};
    position: relative;
    z-index: 50;
`;

export const SearchBox = styled.div`
    position: relative;
    width: 100%;
`;

export const SearchInput = styled.input`
    width: 100%;
    padding: 10px 14px 10px 40px;
    border-radius: 10px;
    border: 1px solid ${props => props.theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.14)' : 'rgba(0, 0, 0, 0.15)'};
    background: ${props => props.theme.palette.mode === 'dark' ? 'rgba(20, 24, 38, 0.85)' : 'rgba(255, 255, 255, 0.95)'};
    color: ${props => props.theme.palette.mode === 'dark' ? '#fff' : tokens(props.theme.palette.mode).grey[100]};
    font-size: 0.9rem;
    outline: none;
    transition: all 0.2s ease;

    &:focus {
        border-color: ${props => props.theme.palette.primary.main};
        box-shadow: 0 0 12px rgba(76, 206, 172, 0.25);
    }

    &::placeholder {
        color: ${props => tokens(props.theme.palette.mode).grey[500]};
    }
`;

export const SearchIconWrapper = styled.div`
    position: absolute;
    left: 14px;
    top: 50%;
    transform: translateY(-50%);
    color: ${props => tokens(props.theme.palette.mode).grey[400]};
    display: flex;
    align-items: center;
    pointer-events: none;
`;

export const ClearSearchBtn = styled.button`
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    background: transparent;
    border: none;
    color: ${props => tokens(props.theme.palette.mode).grey[400]};
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px;
    border-radius: 50%;
    transition: all 0.2s;

    &:hover {
        color: #fff;
        background: rgba(255, 255, 255, 0.12);
    }
`;

export const SuggestionsDropdown = styled.div`
    position: absolute;
    top: calc(100% + 8px);
    left: 0;
    right: 0;
    background: ${props => props.theme.palette.mode === 'dark' ? 'rgba(16, 21, 36, 0.98)' : 'rgba(255, 255, 255, 0.98)'};
    backdrop-filter: blur(16px);
    -webkit-backdrop-filter: blur(16px);
    border: 1px solid ${props => props.theme.palette.mode === 'dark' ? 'rgba(128, 203, 196, 0.35)' : 'rgba(15, 118, 110, 0.3)'};
    border-radius: 12px;
    box-shadow: 0 16px 40px rgba(0, 0, 0, 0.5), 0 0 24px rgba(76, 206, 172, 0.15);
    max-height: 400px;
    overflow-y: auto;
    z-index: 100;
    animation: slideDown 0.15s ease-out;

    @keyframes slideDown {
        from { opacity: 0; transform: translateY(-6px); }
        to { opacity: 1; transform: translateY(0); }
    }

    &::-webkit-scrollbar {
        width: 6px;
    }
    &::-webkit-scrollbar-thumb {
        background: ${props => tokens(props.theme.palette.mode).grey[500]};
        border-radius: 3px;
    }
`;

export const SuggestionsHeader = styled.div`
    padding: 10px 16px;
    font-size: 0.74rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: ${props => props.theme.palette.primary.main};
    border-bottom: 1px solid ${props => props.theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.06)' : 'rgba(0, 0, 0, 0.06)'};
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: ${props => props.theme.palette.mode === 'dark' ? 'rgba(12, 16, 28, 0.7)' : 'rgba(245, 247, 250, 0.8)'};
`;

export const SuggestionItem = styled.div`
    padding: 12px 16px;
    cursor: pointer;
    border-bottom: 1px solid ${props => props.theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.04)' : 'rgba(0, 0, 0, 0.04)'};
    transition: all 0.15s ease;
    background: ${props => props.active
        ? (props.theme.palette.mode === 'dark' ? 'rgba(76, 206, 172, 0.14)' : 'rgba(15, 118, 110, 0.08)')
        : 'transparent'};

    &:hover {
        background: ${props => props.theme.palette.mode === 'dark' ? 'rgba(76, 206, 172, 0.15)' : 'rgba(15, 118, 110, 0.1)'};
    }

    &:last-child {
        border-bottom: none;
    }
`;

export const SuggestionTitleRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    margin-bottom: 5px;
`;

export const SuggestionTitle = styled.div`
    font-size: 0.88rem;
    font-weight: 600;
    color: ${props => props.theme.palette.mode === 'dark' ? '#f1f5f9' : '#0f172a'};
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const SuggestionSnippet = styled.div`
    font-size: 0.78rem;
    line-height: 1.45;
    color: ${props => tokens(props.theme.palette.mode).grey[400]};
    margin-top: 3px;
    display: flex;
    align-items: baseline;
    gap: 8px;
`;

export const SnippetBadge = styled.span`
    font-size: 0.68rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    padding: 1px 6px;
    border-radius: 4px;
    background: ${props => props.theme.palette.mode === 'dark' ? 'rgba(68, 138, 255, 0.15)' : 'rgba(37, 99, 235, 0.1)'};
    color: #448aff;
    flex-shrink: 0;
`;

export const BodyLayout = styled.div`
    flex: 1;
    display: flex;
    overflow: hidden;
    position: relative;
    min-height: 0;
    height: 100%;
`;

export const CollapseToggleBtn = styled.button`
    position: absolute;
    top: 14px;
    left: ${props => props.$isOpen ? '345px' : '12px'};
    width: 28px;
    height: 28px;
    border-radius: 8px;
    border: 1px solid ${props => props.$isOpen
        ? (props.theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.15)' : 'rgba(0, 0, 0, 0.12)')
        : (props.theme.palette.mode === 'dark' ? 'rgba(128, 203, 196, 0.6)' : 'rgba(15, 118, 110, 0.5)')};
    background: ${props => props.$isOpen
        ? (props.theme.palette.mode === 'dark' ? 'rgba(20, 26, 44, 0.95)' : '#ffffff')
        : (props.theme.palette.mode === 'dark' ? 'linear-gradient(135deg, rgba(76, 206, 172, 0.25), rgba(20, 26, 44, 0.95))' : 'linear-gradient(135deg, #0f766e, #14b8a6)')};
    color: ${props => props.$isOpen
        ? (props.theme.palette.mode === 'dark' ? '#cfd8dc' : '#334155')
        : (props.theme.palette.mode === 'dark' ? '#80cbc4' : '#ffffff')};
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 40;
    box-shadow: ${props => props.$isOpen ? '0 2px 8px rgba(0, 0, 0, 0.3)' : '0 4px 14px rgba(76, 206, 172, 0.35)'};
    transition: left 0.25s cubic-bezier(0.4, 0, 0.2, 1),
                background 0.2s ease,
                border-color 0.2s ease,
                color 0.2s ease,
                transform 0.15s ease;

    &:hover {
        transform: scale(1.08);
        border-color: ${props => props.theme.palette.primary.main};
        color: ${props => props.theme.palette.primary.main};
    }
`;

export const Sidebar = styled.div`
    width: ${props => props.$isOpen ? '360px' : '0px'};
    min-width: ${props => props.$isOpen ? '300px' : '0px'};
    opacity: ${props => props.$isOpen ? '1' : '0'};
    overflow: hidden;
    pointer-events: ${props => props.$isOpen ? 'auto' : 'none'};
    border-right: ${props => props.$isOpen
        ? (props.theme.palette.mode === 'dark' ? '1px solid rgba(255, 255, 255, 0.06)' : '1px solid rgba(0, 0, 0, 0.06)')
        : 'none'};
    display: flex;
    flex-direction: column;
    background: ${props => props.theme.palette.mode === 'dark' ? 'rgba(14, 18, 30, 0.5)' : 'rgba(248, 249, 252, 0.6)'};
    transition: width 0.25s cubic-bezier(0.4, 0, 0.2, 1),
                min-width 0.25s cubic-bezier(0.4, 0, 0.2, 1),
                opacity 0.2s ease;
    white-space: nowrap;
    height: 100%;
    min-height: 0;
`;

export const TermsList = styled.div`
    flex: 1;
    height: 100%;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
    scroll-behavior: smooth;

    /* Hide scrollbar for Chrome, Safari and Opera */
    &::-webkit-scrollbar {
        display: none;
        width: 0;
        height: 0;
    }
    /* Hide scrollbar for IE, Edge and Firefox */
    -ms-overflow-style: none;
    scrollbar-width: none;
`;

export const ScrollNavBtn = styled.button`
    width: 100%;
    height: 32px;
    background: ${props => props.theme.palette.mode === 'dark'
        ? 'linear-gradient(180deg, rgba(20, 26, 44, 0.98), rgba(14, 18, 30, 0.9))'
        : 'linear-gradient(180deg, rgba(255, 255, 255, 0.98), rgba(240, 242, 246, 0.9))'};
    border: none;
    border-bottom: ${props => props.$direction === 'up'
        ? (props.theme.palette.mode === 'dark' ? '1px solid rgba(255, 255, 255, 0.08)' : '1px solid rgba(0, 0, 0, 0.06)')
        : 'none'};
    border-top: ${props => props.$direction === 'down'
        ? (props.theme.palette.mode === 'dark' ? '1px solid rgba(255, 255, 255, 0.08)' : '1px solid rgba(0, 0, 0, 0.06)')
        : 'none'};
    color: ${props => props.$isInactive
        ? (props.theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.25)' : 'rgba(0, 0, 0, 0.25)')
        : (props.theme.palette.mode === 'dark' ? '#80cbc4' : '#0f766e')};
    opacity: ${props => props.$isInactive ? 0.4 : 1};
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s ease;
    flex-shrink: 0;
    z-index: 10;
    box-shadow: ${props => props.$direction === 'up'
        ? '0 4px 10px rgba(0, 0, 0, 0.15)'
        : '0 -4px 10px rgba(0, 0, 0, 0.15)'};

    &:hover {
        background: ${props => props.theme.palette.mode === 'dark' ? 'rgba(76, 206, 172, 0.15)' : 'rgba(15, 118, 110, 0.1)'};
        color: ${props => props.theme.palette.mode === 'dark' ? '#4cceac' : '#0f766e'};
        opacity: 1;
    }
`;

export const CategoryGroup = styled.div`
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid ${props => props.theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.05)'};
`;

export const CategoryHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    cursor: pointer;
    user-select: none;
    transition: background 0.18s ease, color 0.18s ease;
    background: ${props => props.$isExpanded
        ? (props.theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.03)' : 'rgba(0, 0, 0, 0.025)')
        : 'transparent'};

    &:hover {
        background: ${props => props.theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.06)' : 'rgba(0, 0, 0, 0.04)'};
    }
`;

export const CategoryHeaderLeft = styled.div`
    display: flex;
    align-items: center;
    gap: 9px;
    min-width: 0;
    overflow: hidden;
`;

export const CategoryChevron = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: ${props => props.$isExpanded
        ? (props.theme.palette.mode === 'dark' ? '#80cbc4' : '#0f766e')
        : (props.theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.45)' : 'rgba(0, 0, 0, 0.45)')};
    transition: transform 0.22s cubic-bezier(0.4, 0, 0.2, 1), color 0.18s ease;
    transform: ${props => props.$isExpanded ? 'rotate(90deg)' : 'rotate(0deg)'};
    flex-shrink: 0;

    ${CategoryHeader}:hover & {
        color: ${props => props.theme.palette.mode === 'dark' ? '#80cbc4' : '#0f766e'};
    }
`;

export const CategoryTitle = styled.span`
    font-size: 0.78rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: ${props => props.$hasSelected
        ? (props.theme.palette.mode === 'dark' ? '#80cbc4' : '#0f766e')
        : (props.theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.82)' : 'rgba(0, 0, 0, 0.78)')};
    transition: color 0.18s ease;

    ${CategoryHeader}:hover & {
        color: ${props => props.theme.palette.mode === 'dark' ? '#ffffff' : '#000000'};
    }
`;

export const CategoryCountBadge = styled.span`
    font-size: 0.68rem;
    font-weight: 600;
    padding: 1px 7px;
    border-radius: 10px;
    background: ${props => props.$hasSelected
        ? (props.theme.palette.mode === 'dark' ? 'rgba(76, 206, 172, 0.18)' : 'rgba(15, 118, 110, 0.14)')
        : (props.theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.06)' : 'rgba(0, 0, 0, 0.05)')};
    color: ${props => props.$hasSelected
        ? (props.theme.palette.mode === 'dark' ? '#80cbc4' : '#0f766e')
        : (props.theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.5)' : 'rgba(0, 0, 0, 0.5)')};
    border: 1px solid ${props => props.$hasSelected
        ? (props.theme.palette.mode === 'dark' ? 'rgba(128, 203, 196, 0.3)' : 'rgba(15, 118, 110, 0.3)')
        : 'transparent'};
    flex-shrink: 0;
    transition: all 0.18s ease;
`;

export const CategoryTermsContainer = styled.div`
    display: flex;
    flex-direction: column;
    background: ${props => props.theme.palette.mode === 'dark' ? 'rgba(0, 0, 0, 0.12)' : 'rgba(0, 0, 0, 0.02)'};
`;

export const TermItem = styled.div`
    padding: 10px 16px 10px 28px;
    min-height: 40px;
    border-bottom: 1px solid ${props => props.theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.025)' : 'rgba(0, 0, 0, 0.025)'};
    cursor: pointer;
    transition: all 0.18s ease;
    position: relative;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    background: ${props => props.selected
        ? (props.theme.palette.mode === 'dark' ? 'rgba(76, 206, 172, 0.12)' : 'rgba(15, 118, 110, 0.08)')
        : 'transparent'};

    border-left: 3px solid ${props => props.selected
        ? (props.theme.palette.mode === 'dark' ? '#80cbc4' : '#0f766e')
        : 'transparent'};

    &:hover {
        background: ${props => props.theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.04)' : 'rgba(0, 0, 0, 0.03)'};
    }
`;

export const TermBullet = styled.span`
    width: 5px;
    height: 5px;
    border-radius: 50%;
    margin-right: 9px;
    flex-shrink: 0;
    background: ${props => props.$selected
        ? (props.theme.palette.mode === 'dark' ? '#80cbc4' : '#0f766e')
        : (props.theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.25)' : 'rgba(0, 0, 0, 0.25)')};
    transition: background 0.18s ease;
`;

export const TermItemTitle = styled.div`
    font-size: 0.85rem;
    font-weight: ${props => props.selected ? 600 : 500};
    color: ${props => props.selected
        ? (props.theme.palette.mode === 'dark' ? '#80cbc4' : '#0f766e')
        : (props.theme.palette.mode === 'dark' ? '#e2e8f0' : '#1e293b')};
    line-height: 1.35;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const DetailPanel = styled.div`
    flex: 1;
    height: 100%;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 28px 36px;
    padding-left: ${props => props.$isSidebarOpen ? '36px' : '56px'};
    display: flex;
    flex-direction: column;
    gap: 22px;
    background: ${props => props.theme.palette.mode === 'dark' ? 'transparent' : 'rgba(255, 255, 255, 0.4)'};
    transition: padding-left 0.25s cubic-bezier(0.4, 0, 0.2, 1);
    scrollbar-width: thin;
    scrollbar-color: ${props => props.theme.palette.mode === 'dark'
        ? 'rgba(128, 203, 196, 0.45) rgba(0, 0, 0, 0.2)'
        : 'rgba(15, 118, 110, 0.35) rgba(0, 0, 0, 0.04)'};

    &::-webkit-scrollbar {
        width: 8px;
    }
    &::-webkit-scrollbar-track {
        background: ${props => props.theme.palette.mode === 'dark' ? 'rgba(0, 0, 0, 0.2)' : 'rgba(0, 0, 0, 0.04)'};
        border-radius: 4px;
    }
    &::-webkit-scrollbar-thumb {
        background: ${props => props.theme.palette.mode === 'dark'
            ? 'rgba(128, 203, 196, 0.45)'
            : 'rgba(15, 118, 110, 0.35)'};
        border-radius: 4px;
        border: 2px solid transparent;
        background-clip: content-box;
    }
    &::-webkit-scrollbar-thumb:hover {
        background: ${props => props.theme.palette.mode === 'dark'
            ? '#80cbc4'
            : '#0f766e'};
    }
`;

export const DetailHeader = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
    border-bottom: 1px solid ${props => props.theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.08)' : 'rgba(0, 0, 0, 0.08)'};
    padding-bottom: 18px;
`;

export const DetailTitle = styled.h1`
    margin: 0;
    font-size: 1.55rem;
    font-weight: 700;
    color: ${props => props.theme.palette.mode === 'dark' ? '#fff' : tokens(props.theme.palette.mode).grey[100]};
    line-height: 1.25;
`;

export const DetailMetaRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
    margin-top: 10px;
`;

export const CategoryBadge = styled.span`
    padding: 3px 10px;
    border-radius: 6px;
    font-size: 0.75rem;
    font-weight: 600;
    background: ${props => props.theme.palette.mode === 'dark' ? 'rgba(68, 138, 255, 0.15)' : 'rgba(37, 99, 235, 0.1)'};
    color: #448aff;
    border: 1px solid ${props => props.theme.palette.mode === 'dark' ? 'rgba(68, 138, 255, 0.3)' : 'rgba(37, 99, 235, 0.2)'};
`;

export const CustomBadge = styled.span`
    padding: 3px 8px;
    border-radius: 6px;
    font-size: 0.72rem;
    font-weight: 600;
    background: ${props => props.theme.palette.mode === 'dark' ? 'rgba(255, 179, 0, 0.15)' : 'rgba(217, 119, 6, 0.1)'};
    color: #ffb300;
    border: 1px solid rgba(255, 179, 0, 0.3);
`;

export const ShortDefCallout = styled.div`
    padding: 16px 20px;
    border-radius: 12px;
    background: ${props => props.theme.palette.mode === 'dark'
        ? 'linear-gradient(145deg, rgba(76, 206, 172, 0.08), rgba(20, 26, 40, 0.6))'
        : 'linear-gradient(145deg, rgba(15, 118, 110, 0.06), rgba(255, 255, 255, 0.9))'};
    border-left: 4px solid ${props => props.theme.palette.primary.main};
    border-top: 1px solid ${props => props.theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.06)' : 'rgba(0, 0, 0, 0.06)'};
    border-right: 1px solid ${props => props.theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.06)' : 'rgba(0, 0, 0, 0.06)'};
    border-bottom: 1px solid ${props => props.theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.06)' : 'rgba(0, 0, 0, 0.06)'};
    font-size: 0.96rem;
    line-height: 1.6;
    color: ${props => props.theme.palette.mode === 'dark' ? '#e6edf7' : '#1f2937'};
    font-weight: 500;
`;

export const SectionBlock = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const SectionHeading = styled.h4`
    margin: 0;
    font-size: 0.85rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.07em;
    color: ${props => props.theme.palette.primary.main};
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const DiagramContainer = styled.div`
    position: relative;
    background: ${props => props.theme.palette.mode === 'dark' ? '#090d18' : '#0f172a'};
    border: 1px solid ${props => props.theme.palette.mode === 'dark' ? 'rgba(128, 203, 196, 0.2)' : 'rgba(255, 255, 255, 0.1)'};
    border-radius: 12px;
    padding: 18px 20px;
    overflow-x: auto;
    box-shadow: inset 0 2px 10px rgba(0, 0, 0, 0.5);

    pre {
        margin: 0;
        font-family: 'JetBrains Mono', 'Consolas', 'Courier New', monospace;
        font-size: 0.84rem;
        line-height: 1.45;
        color: #80cbc4;
        white-space: pre;
    }
`;

export const CopyDiagramBtn = styled.button`
    position: absolute;
    top: 10px;
    right: 10px;
    width: 28px;
    height: 28px;
    border-radius: 6px;
    border: 1px solid rgba(255, 255, 255, 0.15);
    background: rgba(255, 255, 255, 0.08);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
        background: rgba(255, 255, 255, 0.18);
        border-color: rgba(128, 203, 196, 0.4);
    }
`;

export const DocSectionCard = styled.div`
    background: ${props => props.theme.palette.mode === 'dark'
        ? 'linear-gradient(155deg, rgba(22, 28, 48, 0.75) 0%, rgba(13, 17, 30, 0.85) 100%)'
        : 'linear-gradient(155deg, rgba(255, 255, 255, 0.98) 0%, rgba(246, 248, 252, 0.92) 100%)'};
    border: 1px solid ${props => props.theme.palette.mode === 'dark'
        ? 'rgba(128, 203, 196, 0.16)'
        : 'rgba(15, 118, 110, 0.12)'};
    border-radius: 14px;
    padding: 20px 22px;
    margin-bottom: 16px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.22);
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);

    &:hover {
        border-color: ${props => props.theme.palette.mode === 'dark' ? 'rgba(128, 203, 196, 0.35)' : 'rgba(15, 118, 110, 0.28)'};
        box-shadow: 0 8px 30px rgba(0, 0, 0, 0.32), 0 0 20px rgba(76, 206, 172, 0.05);
    }
`;

export const DocSectionHeader = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 14px;
    padding-bottom: 12px;
    border-bottom: 1px solid ${props => props.theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.06)' : 'rgba(0, 0, 0, 0.06)'};
`;

export const DocSectionBadge = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 28px;
    height: 28px;
    padding: 0 8px;
    border-radius: 8px;
    font-size: 0.78rem;
    font-weight: 800;
    font-family: 'JetBrains Mono', monospace;
    background: ${props => props.badgeBg || 'linear-gradient(135deg, #10b981, #059669)'};
    color: #ffffff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
    letter-spacing: 0.04em;
`;

export const DocSectionTitle = styled.h3`
    margin: 0;
    font-size: 1.05rem;
    font-weight: 700;
    letter-spacing: -0.01em;
    color: ${props => props.theme.palette.mode === 'dark' ? '#f8fafc' : '#0f172a'};
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;

    em {
        font-weight: 400 !important;
        font-style: italic !important;
        color: ${props => props.theme.palette.mode === 'dark' ? '#94a3b8' : '#64748b'};
    }
`;

export const DocSectionSubtitle = styled.div`
    font-size: 0.84rem;
    font-style: italic !important;
    color: ${props => props.$isWarning ? (props.theme.palette.mode === 'dark' ? '#fbbf24' : '#d97706') : (props.theme.palette.mode === 'dark' ? '#94a3b8' : '#64748b')};
    font-weight: ${props => props.$isWarning ? '600' : '400 !important'};
    line-height: 1.35;
    margin-top: 2px;
    display: inline-flex;
    align-items: center;
    gap: 6px;
`;

export const DocParagraph = styled.p`
    margin: 0 0 12px 0;
    font-size: 0.92rem;
    line-height: 1.7;
    color: ${props => props.theme.palette.mode === 'dark' ? '#cbd5e1' : '#334155'};

    strong {
        color: ${props => props.theme.palette.mode === 'dark' ? '#ffffff' : '#0f172a'};
        font-weight: 700;
    }
`;

export const DocFormulaPill = styled.div`
    display: inline-flex;
    align-items: center;
    gap: 10px;
    padding: 10px 18px;
    margin: 10px 0 14px 0;
    border-radius: 10px;
    background: ${props => props.theme.palette.mode === 'dark'
        ? 'linear-gradient(90deg, rgba(76, 206, 172, 0.16) 0%, rgba(20, 184, 166, 0.06) 100%)'
        : 'linear-gradient(90deg, rgba(15, 118, 110, 0.1) 0%, rgba(13, 148, 136, 0.04) 100%)'};
    border: 1px solid ${props => props.theme.palette.mode === 'dark' ? 'rgba(76, 206, 172, 0.45)' : 'rgba(15, 118, 110, 0.3)'};
    color: ${props => props.theme.palette.mode === 'dark' ? '#80cbc4' : '#0f766e'};
    font-family: 'JetBrains Mono', monospace;
    font-size: 0.92rem;
    font-weight: 700;
    box-shadow: 0 0 24px rgba(76, 206, 172, 0.12);
`;

export const DocPivotCard = styled.div`
    background: ${props => props.bg || 'rgba(16, 185, 129, 0.05)'};
    border: 1px solid ${props => props.border || 'rgba(16, 185, 129, 0.25)'};
    border-left: 4px solid ${props => props.accent || '#10b981'};
    border-radius: 10px;
    padding: 14px 18px;
    margin: 12px 0;
`;

export const DocPivotHeader = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 8px;
`;

export const DocPivotBadge = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 3px 10px;
    border-radius: 6px;
    font-size: 0.78rem;
    font-weight: 700;
    background: ${props => props.bg || 'rgba(16, 185, 129, 0.2)'};
    color: ${props => props.color || '#34d399'};
    border: 1px solid ${props => props.border || 'rgba(16, 185, 129, 0.4)'};
`;

export const InvalidationAlert = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 10px;
    margin-top: 10px;
    padding: 10px 14px;
    border-radius: 8px;
    background: ${props => props.theme.palette.mode === 'dark' ? 'rgba(239, 68, 68, 0.1)' : 'rgba(239, 68, 68, 0.07)'};
    border: 1px solid ${props => props.theme.palette.mode === 'dark' ? 'rgba(239, 68, 68, 0.3)' : 'rgba(239, 68, 68, 0.2)'};
    color: ${props => props.theme.palette.mode === 'dark' ? '#fca5a5' : '#b91c1c'};
    font-size: 0.85rem;
    line-height: 1.5;
`;

export const KeyPrincipleBox = styled.div`
    background: ${props => props.theme.palette.mode === 'dark'
        ? 'linear-gradient(145deg, rgba(245, 158, 11, 0.09) 0%, rgba(217, 119, 6, 0.03) 100%)'
        : 'linear-gradient(145deg, rgba(245, 158, 11, 0.07) 0%, rgba(254, 243, 199, 0.5) 100%)'};
    border: 1px solid ${props => props.theme.palette.mode === 'dark' ? 'rgba(245, 158, 11, 0.35)' : 'rgba(217, 119, 6, 0.25)'};
    border-radius: 12px;
    padding: 18px 20px;
    margin-top: 16px;
    box-shadow: 0 4px 20px rgba(245, 158, 11, 0.08);
`;

export const KeyPrincipleRow = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 9px 12px;
    border-radius: 8px;
    margin-top: 8px;
    background: ${props => props.isConfluence
        ? (props.theme.palette.mode === 'dark' ? 'rgba(245, 158, 11, 0.16)' : 'rgba(245, 158, 11, 0.15)')
        : (props.theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.03)' : 'rgba(0, 0, 0, 0.02)')};
    border: 1px solid ${props => props.isConfluence
        ? (props.theme.palette.mode === 'dark' ? 'rgba(245, 158, 11, 0.45)' : 'rgba(245, 158, 11, 0.4)')
        : (props.theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.04)')};
    font-size: 0.88rem;
    color: ${props => props.theme.palette.mode === 'dark' ? '#f1f5f9' : '#1e293b'};
`;

export const TimeframeSpectrumCard = styled.div`
    background: ${props => props.theme.palette.mode === 'dark'
        ? 'linear-gradient(145deg, rgba(15, 23, 42, 0.85) 0%, rgba(30, 41, 59, 0.6) 100%)'
        : 'linear-gradient(145deg, #f8fafc 0%, #f1f5f9 100%)'};
    border: 1px solid ${props => props.theme.palette.mode === 'dark' ? 'rgba(56, 189, 248, 0.3)' : 'rgba(14, 165, 233, 0.3)'};
    border-radius: 12px;
    padding: 16px 18px;
    margin: 12px 0 16px 0;
    box-shadow: ${props => props.theme.palette.mode === 'dark'
        ? '0 4px 20px rgba(0, 0, 0, 0.35), inset 0 1px 0 rgba(255, 255, 255, 0.05)'
        : '0 4px 16px rgba(0, 0, 0, 0.05)'};
`;

export const TimeframeSpectrumHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 12px;
    padding-bottom: 8px;
    border-bottom: 1px solid ${props => props.theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.07)' : 'rgba(0, 0, 0, 0.06)'};
`;

export const TimeframeSpectrumTitle = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 0.82rem;
    font-weight: 700;
    color: ${props => props.theme.palette.mode === 'dark' ? '#38bdf8' : '#0284c7'};
    letter-spacing: 0.04em;
    text-transform: uppercase;
`;

export const TimeframeLegend = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    font-size: 0.74rem;
    font-weight: 600;
`;

export const TimeframeTrack = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px;
    padding: 10px 12px;
    border-radius: 8px;
    background: ${props => props.theme.palette.mode === 'dark' ? 'rgba(0, 0, 0, 0.3)' : 'rgba(255, 255, 255, 0.75)'};
    border: 1px solid ${props => props.theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.05)'};
`;

export const TimeframePill = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 38px;
    padding: 4px 9px;
    border-radius: 6px;
    font-family: 'JetBrains Mono', monospace;
    font-size: 0.82rem;
    font-weight: 700;
    background: ${props => props.bg};
    color: ${props => props.color};
    border: 1px solid ${props => props.border};
    box-shadow: 0 2px 6px ${props => props.glow || 'transparent'};
    transition: all 0.2s ease;
    user-select: none;

    &:hover {
        transform: translateY(-1px);
        filter: brightness(1.15);
    }
`;

export const TimeframeArrow = styled.span`
    color: ${props => props.theme.palette.mode === 'dark' ? '#64748b' : '#94a3b8'};
    font-size: 0.82rem;
    font-weight: 700;
    user-select: none;
`;

export const TimeframeStepRuleBox = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    margin-top: 12px;
    padding: 9px 12px;
    border-radius: 7px;
    background: ${props => props.theme.palette.mode === 'dark' ? 'rgba(56, 189, 248, 0.07)' : 'rgba(14, 165, 233, 0.06)'};
    border: 1px solid ${props => props.theme.palette.mode === 'dark' ? 'rgba(56, 189, 248, 0.25)' : 'rgba(14, 165, 233, 0.2)'};
    font-size: 0.84rem;
    line-height: 1.45;
    color: ${props => props.theme.palette.mode === 'dark' ? '#cbd5e1' : '#1e293b'};
`;

export const VolatilityVsMomentumCard = styled.div`
    background: ${props => props.theme.palette.mode === 'dark'
        ? 'linear-gradient(145deg, rgba(15, 23, 42, 0.85) 0%, rgba(30, 41, 59, 0.6) 100%)'
        : 'linear-gradient(145deg, #f8fafc 0%, #f1f5f9 100%)'};
    border: 1px solid ${props => props.theme.palette.mode === 'dark' ? 'rgba(56, 189, 248, 0.3)' : 'rgba(14, 165, 233, 0.3)'};
    border-radius: 12px;
    padding: 16px 18px;
    margin: 16px 0;
    box-shadow: ${props => props.theme.palette.mode === 'dark'
        ? '0 4px 20px rgba(0, 0, 0, 0.35), inset 0 1px 0 rgba(255, 255, 255, 0.05)'
        : '0 4px 16px rgba(0, 0, 0, 0.05)'};
`;

export const DocBulletList = styled.ul`
    margin: 8px 0 12px 0;
    padding-left: 0;
    list-style-type: none;
`;

export const DocBulletItem = styled.li`
    position: relative;
    padding-left: ${props => props.isChecklist ? '4px' : props.isNumbered ? (props.isSubSub ? '52px' : '36px') : props.isSubSub ? '52px' : props.isActionItem ? '20px' : props.isSubItem ? '36px' : props.isMicro ? '24px' : '20px'};
    margin-bottom: ${props => props.isChecklist ? '6px' : props.isActionItem ? '6px' : props.isSubSub ? '4px' : props.isMetaItem ? '3px' : props.isSubItem ? '4px' : '8px'};
    font-size: ${props => props.isActionItem ? '0.88rem' : props.isSubSub ? '0.85rem' : props.isMetaItem ? '0.84rem' : props.isSubItem ? '0.88rem' : '0.91rem'};
    line-height: ${props => props.isMetaItem ? '1.5' : '1.6'};
    color: ${props => props.isActionItem ? (props.theme.palette.mode === 'dark' ? '#f1f5f9' : '#0f172a') : props.isSubSub ? (props.theme.palette.mode === 'dark' ? '#cbd5e1' : '#334155') : props.isMetaItem ? (props.theme.palette.mode === 'dark' ? '#94a3b8' : '#64748b') : props.isOptional ? '#94a3b8' : props.isSubItem ? (props.theme.palette.mode === 'dark' ? '#cbd5e1' : '#334155') : (props.theme.palette.mode === 'dark' ? '#cbd5e1' : '#334155')};

    ${props => props.isActionItem && `
        font-weight: 550;
        color: rgba(125, 211, 252, 0.9) !important;
    `}

    &::before {
        content: "${props => (props.isActionItem || props.isNumbered || props.isChecklist) ? '' : props.isSubSub ? '›' : props.isMetaItem ? '›' : props.isOptional ? '○' : props.isRequired ? '●' : props.isSubItem ? '○' : props.isMicro ? '⚡' : '◆'}";
        display: ${props => (props.isActionItem || props.isNumbered || props.isChecklist) ? 'none' : 'block'};
        position: absolute;
        left: ${props => props.isSubSub ? '36px' : props.isSubItem ? (props.isMetaItem ? '20px' : '18px') : props.isMicro ? '6px' : '0'};
        top: ${props => props.isMetaItem ? '0px' : (props.isRequired || props.isOptional) ? '1px' : props.isSubSub ? '1px' : props.isSubItem ? '4px' : '2px'};
        font-size: ${props => props.isMetaItem ? '0.82rem' : (props.isRequired || props.isOptional) ? '0.66rem' : props.isSubSub ? '0.84rem' : props.isSubItem ? '0.52rem' : props.isMicro ? '0.72rem' : '0.65rem'};
        color: ${props => props.isSubSub ? 'rgba(56, 189, 248, 0.45)' : props.isMetaItem ? '#64748b' : props.isOptional ? '#94a3b8' : props.isRequired ? '#7dd3fc' : props.isSubItem ? 'rgba(56, 189, 248, 0.55)' : props.isMicro ? '#c084fc' : 'rgba(76, 206, 172, 0.65)'};
    }

    strong {
        color: ${props => props.isRequired ? '#7dd3fc' : props.isMicro ? '#e9d5ff' : props.theme.palette.mode === 'dark' ? '#e2e8f0' : '#1e293b'};
        font-weight: 600;
    }

    strong.doc-bold-italic,
    .doc-bold-italic {
        color: ${props => props.theme.palette.mode === 'dark' ? '#e2e8f0' : '#475569'} !important;
        font-style: italic;
        font-weight: 600;
        letter-spacing: 0.01em;
    }

    em {
        color: ${props => props.isOptional ? '#94a3b8' : 'inherit'};
        font-style: italic !important;
        font-weight: 400 !important;
    }
`;

export const DocSubSectionHeader = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    margin: 22px 0 10px 0;
    padding-bottom: 8px;
    border-bottom: 1px solid ${props => props.theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.08)' : 'rgba(0, 0, 0, 0.08)'};

    &:first-of-type {
        margin-top: 12px;
    }
`;

export const DocSubSectionBadge = styled.div`
    padding: 2px 8px;
    border-radius: 6px;
    font-size: 0.76rem;
    font-weight: 800;
    letter-spacing: 0.5px;
    background: linear-gradient(135deg, rgba(56, 189, 248, 0.22), rgba(14, 165, 233, 0.12));
    border: 1px solid rgba(56, 189, 248, 0.4);
    color: #38bdf8;
    box-shadow: 0 2px 6px rgba(56, 189, 248, 0.12);
    display: inline-flex;
    align-items: center;
    justify-content: center;
`;

export const DocSubSectionTitle = styled.h4`
    margin: 0;
    font-size: 0.98rem;
    font-weight: 700;
    color: ${props => props.theme.palette.mode === 'dark' ? '#f1f5f9' : '#0f172a'};
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px;

    em {
        font-weight: 400 !important;
        font-style: italic !important;
        color: ${props => props.theme.palette.mode === 'dark' ? '#94a3b8' : '#64748b'};
    }
`;

export const DocInlineCarouselCard = styled.div`
    background: ${props => props.theme.palette.mode === 'dark' ? '#090d18' : '#f8fafc'};
    border: 1px solid ${props => props.theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.08)' : 'rgba(0, 0, 0, 0.08)'};
    border-radius: 10px;
    overflow: hidden;
    margin: 12px 0 16px;
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.16);
    transition: border-color 0.2s ease, box-shadow 0.2s ease;

    &:hover {
        border-color: rgba(56, 189, 248, 0.35);
        box-shadow: 0 6px 20px rgba(0, 0, 0, 0.22);
    }
`;

export const DocInlineCarouselHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 14px;
    background: ${props => props.theme.palette.mode === 'dark' ? 'rgba(15, 23, 42, 0.8)' : '#f1f5f9'};
    border-bottom: 1px solid ${props => props.theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.06)' : 'rgba(0, 0, 0, 0.06)'};
    gap: 8px;
    flex-wrap: wrap;
`;

export const DocInlineCarouselBadge = styled.div`
    width: 26px;
    height: 26px;
    border-radius: 6px;
    background: linear-gradient(135deg, #06b6d4, #0ea5e9);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
`;

export const DocInlineCarouselCaptionTag = styled.span`
    font-size: 0.8rem;
    font-weight: 500;
    color: #94a3b8;
    background: rgba(255, 255, 255, 0.04);
    padding: 2px 8px;
    border-radius: 5px;
    border: 1px solid rgba(255, 255, 255, 0.07);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 360px;
`;

export const DocInlineCarouselImageArea = styled.div`
    position: relative;
    width: 100%;
    min-height: 220px;
    background: #090d18;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    overflow: hidden;

    img {
        width: 100%;
        height: auto;
        display: block;
        transition: transform 0.25s ease;
    }

    &:hover img {
        transform: scale(1.015);
    }
`;

export const ModernTagBadge = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 5px;
    font-size: 0.72rem;
    font-weight: 650;
    letter-spacing: 0.02em;
    padding: 2px 8px;
    margin: 0 3px;
    border-radius: 6px;
    vertical-align: middle;
    line-height: 1.35;
    user-select: none;
    transition: all 0.16s ease-in-out;
    white-space: nowrap;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.18);
    cursor: ${props => props.$isClickable ? 'pointer' : 'default'};

    &:hover {
        transform: translateY(-1px);
        filter: brightness(1.15);
        box-shadow: 0 3px 8px rgba(0, 0, 0, 0.35);
        ${props => props.$isClickable && `
            transform: translateY(-1.5px) scale(1.03);
            filter: brightness(1.22);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.45);
        `}
    }

    &:active {
        ${props => props.$isClickable && `
            transform: translateY(0) scale(0.98);
        `}
    }
`;

export const ModernTagDot = styled.span`
    display: inline-block;
    width: 5px;
    height: 5px;
    border-radius: 50%;
    flex-shrink: 0;
`;

export const DocTableWrapper = styled.div`
    width: 100%;
    overflow-x: auto;
    margin: 14px 0 18px 0;
    border-radius: 8px;
    border: 1px solid ${props => props.theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.08)' : 'rgba(0, 0, 0, 0.08)'};
    background: ${props => props.theme.palette.mode === 'dark' ? 'rgba(15, 23, 42, 0.55)' : '#f8fafc'};
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.15);
`;

export const DocTable = styled.table`
    width: 100%;
    border-collapse: collapse;
    font-size: 0.84rem;
    text-align: left;
`;

export const DocTh = styled.th`
    background: ${props => props.theme.palette.mode === 'dark' ? 'rgba(30, 41, 59, 0.8)' : '#e2e8f0'};
    color: #38bdf8;
    font-weight: 700;
    padding: 10px 14px;
    border-bottom: 1px solid ${props => props.theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)'};
    white-space: nowrap;
    font-size: 0.78rem;
    letter-spacing: 0.03em;
`;

export const DocTr = styled.tr`
    border-bottom: 1px solid ${props => props.theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.04)' : 'rgba(0, 0, 0, 0.04)'};
    transition: background 0.15s ease;

    &:last-child {
        border-bottom: none;
    }

    &:hover {
        background: rgba(56, 189, 248, 0.04);
    }
`;

export const DocTd = styled.td`
    padding: 10px 14px;
    color: ${props => props.theme.palette.mode === 'dark' ? '#cbd5e1' : '#334155'};
    line-height: 1.55;

    em {
        font-weight: 400 !important;
        font-style: italic;
    }

    &:first-child {
        font-weight: 600;
        color: ${props => props.theme.palette.mode === 'dark' ? '#f1f5f9' : '#0f172a'};
        white-space: nowrap;
        border-right: 1px solid ${props => props.theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.04)' : 'rgba(0, 0, 0, 0.04)'};
        background: ${props => props.theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.015)' : 'rgba(0, 0, 0, 0.015)'};
    }
`;

export const ApplicationBox = styled.div`
    padding: 14px 18px;
    border-radius: 10px;
    background: ${props => props.theme.palette.mode === 'dark' ? 'rgba(255, 179, 0, 0.05)' : 'rgba(217, 119, 6, 0.05)'};
    border: 1px solid ${props => props.theme.palette.mode === 'dark' ? 'rgba(255, 179, 0, 0.22)' : 'rgba(217, 119, 6, 0.2)'};
    color: ${props => props.theme.palette.mode === 'dark' ? '#ffcc80' : '#b45309'};
    font-size: 0.88rem;
    line-height: 1.6;
    display: flex;
    align-items: flex-start;
    gap: 12px;
`;

export const ApplicationCard = styled.div`
    padding: 14px 18px;
    border-radius: 10px;
    background: ${props => props.theme.palette.mode === 'dark' ? 'rgba(255, 179, 0, 0.04)' : 'rgba(217, 119, 6, 0.04)'};
    border: 1px solid ${props => props.theme.palette.mode === 'dark' ? 'rgba(255, 179, 0, 0.18)' : 'rgba(217, 119, 6, 0.18)'};
    color: ${props => props.theme.palette.mode === 'dark' ? '#ffcc80' : '#9a3412'};
    font-size: 0.88rem;
    line-height: 1.6;
    display: flex;
    align-items: flex-start;
    gap: 14px;
    transition: all 0.2s ease;

    &:hover {
        background: ${props => props.theme.palette.mode === 'dark' ? 'rgba(255, 179, 0, 0.07)' : 'rgba(217, 119, 6, 0.07)'};
        border-color: ${props => props.theme.palette.mode === 'dark' ? 'rgba(255, 179, 0, 0.35)' : 'rgba(217, 119, 6, 0.3)'};
    }
`;

export const ApplicationNumberBadge = styled.div`
    width: 28px;
    height: 28px;
    min-width: 28px;
    border-radius: 7px;
    background: linear-gradient(135deg, rgba(245, 158, 11, 0.3), rgba(217, 119, 6, 0.2));
    border: 1px solid rgba(245, 158, 11, 0.45);
    color: #fbbf24;
    font-size: 0.82rem;
    font-weight: 800;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    margin-top: 1px;
    box-shadow: 0 2px 8px rgba(245, 158, 11, 0.15);
`;

export const ApplicationBulletBadge = styled.div`
    width: 24px;
    height: 24px;
    min-width: 24px;
    color: #fbbf24;
    font-size: 0.75rem;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    margin-top: 2px;
`;

export const ApplicationContent = styled.div`
    flex: 1;
    color: ${props => props.theme.palette.mode === 'dark' ? '#fed7aa' : '#7c2d12'};

    strong {
        color: ${props => props.theme.palette.mode === 'dark' ? '#fef08a' : '#451a03'};
        font-weight: 700;
    }

    em {
        color: ${props => props.theme.palette.mode === 'dark' ? '#fde047' : '#9a3412'};
        font-style: italic;
    }

    code {
        background: rgba(245, 158, 11, 0.15);
        color: #fbbf24;
        padding: 2px 6px;
        border-radius: 4px;
        font-size: 0.85em;
        border: 1px solid rgba(245, 158, 11, 0.3);
    }
`;

export const TagsRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: 6px;
`;

export const TagChip = styled.span`
    padding: 3px 8px;
    border-radius: 6px;
    font-size: 0.72rem;
    background: ${props => props.theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.04)'};
    color: ${props => tokens(props.theme.palette.mode).grey[300]};
    border: 1px solid ${props => props.theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.08)' : 'rgba(0, 0, 0, 0.06)'};
    display: flex;
    align-items: center;
    gap: 4px;
`;

export const InlineEditForm = styled.form`
    display: flex;
    flex-direction: column;
    gap: 18px;
    width: 100%;
`;

export const FormGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
`;

export const Label = styled.label`
    font-size: 0.8rem;
    font-weight: 600;
    color: ${props => tokens(props.theme.palette.mode).grey[200]};
    text-transform: uppercase;
    letter-spacing: 0.05em;
`;

export const Input = styled.input`
    padding: 9px 12px;
    border-radius: 8px;
    border: 1px solid ${props => props.theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.15)'};
    background: ${props => props.theme.palette.mode === 'dark' ? '#0f121e' : '#f8fafc'};
    color: ${props => props.theme.palette.mode === 'dark' ? '#fff' : '#0f172a'};
    font-size: 0.88rem;
    outline: none;

    &:focus {
        border-color: ${props => props.theme.palette.primary.main};
    }
`;

export const Select = styled.select`
    padding: 9px 12px;
    border-radius: 8px;
    border: 1px solid ${props => props.theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.15)'};
    background: ${props => props.theme.palette.mode === 'dark' ? '#0f121e' : '#f8fafc'};
    color: ${props => props.theme.palette.mode === 'dark' ? '#fff' : '#0f172a'};
    font-size: 0.88rem;
    outline: none;

    option {
        background: ${props => props.theme.palette.mode === 'dark' ? '#141828' : '#fff'};
    }
`;

export const Textarea = styled.textarea`
    padding: 9px 12px;
    border-radius: 8px;
    border: 1px solid ${props => props.theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.15)'};
    background: ${props => props.theme.palette.mode === 'dark' ? '#0f121e' : '#f8fafc'};
    color: ${props => props.theme.palette.mode === 'dark' ? '#fff' : '#0f172a'};
    font-size: 0.88rem;
    outline: none;
    resize: vertical;
    min-height: 80px;
    font-family: inherit;

    &:focus {
        border-color: ${props => props.theme.palette.primary.main};
    }
`;

export const TextareaMonospace = styled(Textarea)`
    font-family: 'JetBrains Mono', 'Consolas', monospace;
    font-size: 0.82rem;
    white-space: pre;
`;

export const ImageWrapper = styled.div`
    position: relative;
    cursor: zoom-in;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #040712;
    padding: 14px;
    min-height: 180px;
    max-height: 480px;
    overflow: hidden;

    img {
        max-width: 100%;
        max-height: 450px;
        object-fit: contain;
        border-radius: 6px;
        transition: transform 0.25s ease;
    }

    &:hover img {
        transform: scale(1.015);
    }
`;

export const ImageCaptionBar = styled.div`
    padding: 8px 16px;
    font-size: 0.78rem;
    color: ${props => props.theme.palette.mode === 'dark' ? '#94a3b8' : '#64748b'};
    background: rgba(0, 0, 0, 0.25);
    border-top: 1px solid rgba(255, 255, 255, 0.05);
    font-style: italic;
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const LightboxOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.94);
    backdrop-filter: blur(8px);
    z-index: 2500;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 24px;
    cursor: zoom-out;
`;

export const LightboxImg = styled.img`
    max-width: 95vw;
    max-height: 88vh;
    object-fit: contain;
    border-radius: 8px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.9);
    border: 1px solid rgba(76, 206, 172, 0.35);
`;

export const LightboxCloseBtn = styled.button`
    position: absolute;
    top: 20px;
    right: 20px;
    background: rgba(255, 255, 255, 0.15);
    border: 1px solid rgba(255, 255, 255, 0.25);
    color: #fff;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 1.2rem;
    transition: all 0.2s ease;

    &:hover {
        background: rgba(239, 68, 68, 0.85);
        border-color: #ef4444;
    }
`;
